import Cookies from 'js-cookie';

export interface AddFavouritePayload {
  contentfulId: string;
  itemType: string;
  mpId: string;
  locale: string;
}

export interface FavouriteItemResponse {
  contentfulId: string;
  itemType: string;
}

// Map frontend FavouriteType values to what the backend accepts
const ITEM_TYPE_MAP: Record<string, string> = {
  offer: 'offer',
  tenant: 'tenant',
  event: 'event',
  service: 'service',
  // leisurePackageOffer: 'lpo', // TODO: re-enable when LPO favourites are needed
  editorial: 'editorial',
};

function toBackendItemType(itemType: string): string {
  return ITEM_TYPE_MAP[itemType] ?? itemType;
}

// function getToken(): string {
//   return Cookies.get('user_token') ?? '';
// }

export const addFavouriteAPI = async (
  payload: AddFavouritePayload,
): Promise<void> => {
  // const userToken = getToken();

  const response = await fetch('/api/favourites', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      // ...(userToken && { 'X-ICIM-JWT': userToken }),
    },
    body: JSON.stringify({
      ...payload,
      itemType: toBackendItemType(payload.itemType),
    }),
  });

  if (!response.ok) {
    const errorData = await response.json();
    throw {
      status: response.status,
      message: errorData?.message || 'Failed to add favourite',
    };
  }
};

export const removeFavouriteAPI = async (backendId: string): Promise<void> => {
  // const userToken = getToken();

  const response = await fetch(
    `/api/favourites?id=${encodeURIComponent(backendId)}`,
    {
      method: 'DELETE',
      headers: {
        // ...(userToken && { 'X-ICIM-JWT': userToken }),
      },
    },
  );

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    throw {
      status: response.status,
      message: errorData?.message || 'Failed to remove favourite',
    };
  }
};

export const getFavouritesAPI = async (
  mpId: string,
): Promise<FavouriteItemResponse[]> => {
  // const userToken = getToken();

  const response = await fetch(
    `/api/favourites?mpId=${encodeURIComponent(mpId)}`,
    {
      method: 'GET',
      headers: {
        // ...(userToken && { 'X-ICIM-JWT': userToken }),
      },
    },
  );

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    throw {
      status: response.status,
      message: errorData?.message || 'Failed to get favourites',
    };
  }

  const raw = await response.json();
  return raw.favourites ?? [];
};
